export const translations = {
  fr: {
    nav: {
      about: "Le Projet", technical: "Technique", finance: "Modèle Économique",
      esg: "ESG & Impact", monitoring: "Suivi du Projet", partners: "Partenaires",
      invest: "Investir", contact: "Contact", brief: "Télécharger le Brief",
      login: "Se connecter", space: "Espace Investisseur", logout: "Déconnexion",
    },
    hero: {
      tag: "Sénégal · Paoskoto, Kaolack · Modèle BOOT 40 ans",
      line1: "Alimenter l'avenir", line2: "du Sénégal avec une", line3: "énergie durable.",
      sub: "Centrale solaire photovoltaïque de 250 MW couplée à un programme agrivoltaïque et social — un hub énergétique intégré de nouvelle génération en Afrique de l'Ouest.",
      cta1: "Télécharger le Brief Projet", cta2: "Devenir Partenaire",
      k1: "Capacité installée", k2: "Production annuelle", k3: "Cycle de vie",
    },
    about: {
      chapter: "01 — Le Projet",
      title: "Une vision au service de l'indépendance énergétique",
      vision_t: "Notre Vision",
      vision: "Faire de Paoskoto l'un des premiers hubs agrivoltaïques et énergétiques intégrés d'Afrique de l'Ouest, combinant énergie propre, agriculture productive et formation des talents locaux.",
      mission_t: "Notre Mission",
      mission: "Renforcer la production d'énergie renouvelable, améliorer l'accès à l'énergie, favoriser l'emploi et l'entrepreneuriat local, et promouvoir un développement territorial durable.",
      boot_t: "Le modèle BOOT (Build-Own-Operate-Transfer)",
      boot: "Le projet est structuré sur 40 ans selon un modèle BOOT. À l'issue du contrat, la centrale est transférée gratuitement à l'État du Sénégal — garantissant un actif souverain durable.",
      s1_t: "Construire", s1: "Développement et construction de la centrale sur 12 mois.",
      s2_t: "Détenir & Exploiter", s2: "Propriété et exploitation optimisée sur 40 ans.",
      s3_t: "Transférer", s3: "Transfert gratuit de l'actif à l'État en fin de contrat.",
    },
    technical: {
      chapter: "02 — Aperçu Technique",
      title: "Une infrastructure de classe mondiale, optimisée pour le Sahel",
      dc: "Capacité DC", ac: "Capacité AC (injection réseau)",
      prod: "Production annuelle estimée", tech: "Technologie",
      tech_v: "Modules photovoltaïques bifaciaux", surface: "Surface totale du site",
      loc: "Localisation", loc_v: "Paoskoto, Kaolack — Sénégal",
      height: "Structures surélevées", height_v: "≈ 3 m (agrivoltaïque)",
      map_title: "Site du projet", map_desc: "Paoskoto, Région de Kaolack",
      feature: "Optimisation de la production en climat sahélien grâce aux modules bifaciaux et aux structures surélevées permettant le double usage des terres.",
    },
    finance: {
      chapter: "03 — Modèle Économique & Financier",
      title: "Un investissement sécurisé, à faible risque",
      capex: "CAPEX estimé", tariff: "Tarif de vente", ppa: "Durée du PPA",
      lcoe: "LCOE compétitif",
      struct_t: "Structure financière indicative",
      debt: "Dette senior", equity: "Investisseurs quasi-equity", sponsor: "Sponsor",
      rev_t: "Projection de revenus (indicatif, M€/an)",
      guarantees_t: "Garanties & sécurisation",
      g1: "Garantie souveraine de l'État du Sénégal",
      g2: "Revenus sécurisés par un PPA long terme (25 ans)",
      g3: "Acheteur unique : Senelec (off-taker national)",
      g4: "Pool bancaire local : BNDE & BSIC",
    },
    esg: {
      chapter: "04 — ESG & Impact",
      title: "Un impact mesurable sur l'environnement et les communautés",
      env_t: "Environnement", env_v: "9,9 M", env_u: "tonnes de CO₂ évitées",
      env_d: "Réduction des émissions de gaz à effet de serre sur la durée du projet.",
      social_t: "Social", social_v: "1 000+", social_u: "jeunes formés",
      social_d: "Formation rémunérée aux métiers du solaire ; 60 profils vers l'international.",
      women_t: "Autonomisation des femmes", women_v: "Groupements",
      women_d: "Parcelles agricoles dédiées aux groupements féminins pour le maraîchage.",
      econ_t: "Économie locale", econ_v: "Agri + Pêche",
      econ_d: "Agriculture sous panneaux et bassins piscicoles pour la sécurité alimentaire.",
    },
    agri: {
      chapter: "05 — Innovation Agrivoltaïque",
      title: "Un même hectare, deux ressources",
      desc: "L'agrivoltaïque combine production d'énergie et production agricole sur la même surface. Les structures surélevées (≈3 m) permettent de cultiver et d'élever sous les panneaux, protégeant les cultures du soleil intense tout en produisant de l'électricité.",
      u1_t: "Maraîchage pour les femmes",
      u1: "Des groupements féminins bénéficient de parcelles sous les installations pour des activités de maraîchage.",
      u2_t: "Pisciculture pour les jeunes",
      u2: "Des bassins piscicoles soutiennent l'entrepreneuriat des jeunes et la sécurité alimentaire locale.",
      b1: "Double usage des terres", b2: "Protection des cultures", b3: "Revenus complémentaires", b4: "Sécurité alimentaire",
    },
    infra: {
      chapter: "06 — Développement Communautaire",
      title: "Des infrastructures qui renforcent les chaînes de valeur locales",
      i1_t: "Maison des jeunes", i1: "Un espace dédié à la formation et à l'entrepreneuriat des jeunes de la région.",
      i2_t: "Chambres froides", i2: "Stockage froid positif et négatif de grande capacité pour conserver les produits agricoles et piscicoles.",
      i3_t: "Fonds de développement", i3: "Un fonds local finance l'agriculture, la pisciculture et les micro-entreprises à conditions favorables.",
    },
    partners: {
      chapter: "07 — Partenaires",
      title: "Un écosystème d'acteurs de confiance",
      sponsor: "Sponsor", offtaker: "Acheteur (Off-taker)",
      technical: "Partenaire technique", financial: "Partenaires financiers",
    },
    invest: {
      chapter: "08 — Investir",
      title: "Pourquoi investir dans Horizon Affaires Senegal",
      r1_t: "Rendements stables", r1: "Revenus sécurisés par un PPA de 25 ans à tarif fixe.",
      r2_t: "Garanties solides", r2: "Garantie souveraine de l'État et acheteur national Senelec.",
      r3_t: "Impact ESG", r3: "Un actif aligné sur les standards environnementaux et sociaux internationaux.",
      cta1: "Demander le Dossier d'Investissement", cta2: "Contacter l'Équipe Investissement",
    },
    monitoring: {
      chapter: "09 — Innovation : Suivi du Projet",
      title: "Centre de supervision en temps réel",
      subtitle: "Suivez l'avancement du chantier, la production et l'impact — en direct.",
      live: "EN DIRECT", overall: "Avancement global",
      m_output: "Puissance instantanée", m_installed: "Capacité installée",
      m_energy: "Énergie aujourd'hui", m_co2: "CO₂ évité (cumul)", m_workforce: "Effectif sur site",
      phases_t: "Phases du projet",
      p_land: "Préparation du terrain", p_install: "Installation",
      p_grid: "Raccordement réseau", p_commission: "Mise en service",
      prod_t: "Production sur 24h (MW)",
      map_t: "Carte interactive du site",
      map_hint: "Cliquez sur un marqueur pour explorer chaque zone",
      target: "Objectif",
    },
    zones: {
      solar: { name: "Zone Solaire A", type: "Champ photovoltaïque", desc: "Modules bifaciaux sur structures surélevées, cœur de la production électrique." },
      agri: { name: "Zone Agrivoltaïque", type: "Maraîchage", desc: "Cultures maraîchères sous panneaux, exploitées par les groupements féminins." },
      fish: { name: "Bassins Piscicoles", type: "Aquaculture", desc: "Bassins d'élevage soutenant l'entrepreneuriat des jeunes." },
      community: { name: "Pôle Communautaire", type: "Infrastructures", desc: "Maison des jeunes, chambres froides et centre de formation." },
      grid: { name: "Poste de Raccordement", type: "Réseau", desc: "Point d'injection de 250 MWac sur le réseau national Senelec." },
    },
    timeline: {
      chapter: "10 — Calendrier",
      title: "Un projet structuré dans le temps",
      t1_t: "Développement", t1: "Structuration, financement et autorisations.",
      t2_t: "Construction", t2: "12 mois — génie civil, installation, formation.",
      t3_t: "Exploitation", t3: "40 ans d'exploitation optimisée de la centrale.",
      t4_t: "Transfert", t4: "Transfert gratuit de l'actif à l'État du Sénégal.",
    },
    contact: {
      chapter: "11 — Contact",
      title: "Parlons de votre participation au projet",
      name: "Nom complet", email: "Email professionnel", org: "Organisation",
      interest: "Vous êtes", message: "Votre message",
      i_investment: "Investisseur", i_partnership: "Partenaire", i_technical: "Partenaire technique",
      i_press: "Presse", i_general: "Autre",
      send: "Envoyer le message", sending: "Envoi en cours...",
      success: "Message envoyé. Notre équipe vous recontactera rapidement.",
      error: "Une erreur est survenue. Veuillez réessayer.",
      office: "Bureau", office_v: "Dakar, Sénégal",
      ph_name: "Ex. Awa Diop", ph_email: "vous@organisation.com", ph_org: "Ex. Banque / Fonds",
      ph_message: "Décrivez votre intérêt pour le projet...",
    },
    footer: {
      tagline: "Centrale solaire de 250 MW & hub agrivoltaïque intégré — Paoskoto, Sénégal.",
      links: "Navigation", legal: "Informations légales",
      privacy: "Politique de confidentialité", terms: "Mentions légales",
      rights: "Tous droits réservés.",
      contact: "Contact",
    },
  },
  en: {
    nav: {
      about: "The Project", technical: "Technical", finance: "Financial Model",
      esg: "ESG & Impact", monitoring: "Project Monitoring", partners: "Partners",
      invest: "Invest", contact: "Contact", brief: "Download Brief",
      login: "Sign in", space: "Investor Area", logout: "Sign out",
    },
    hero: {
      tag: "Senegal · Paoskoto, Kaolack · 40-year BOOT model",
      line1: "Powering Senegal's", line2: "future with", line3: "sustainable energy.",
      sub: "A 250 MW solar photovoltaic power plant paired with an agrivoltaic and social program — a next-generation integrated energy hub in West Africa.",
      cta1: "Download Project Brief", cta2: "Become a Partner",
      k1: "Installed capacity", k2: "Annual production", k3: "Lifecycle",
    },
    about: {
      chapter: "01 — The Project",
      title: "A vision serving energy independence",
      vision_t: "Our Vision",
      vision: "Make Paoskoto one of West Africa's first integrated agrivoltaic and energy hubs, combining clean energy, productive agriculture and local talent training.",
      mission_t: "Our Mission",
      mission: "Strengthen renewable energy production, improve energy access, foster local jobs and entrepreneurship, and promote sustainable territorial development.",
      boot_t: "The BOOT model (Build-Own-Operate-Transfer)",
      boot: "The project is structured over 40 years under a BOOT model. At the end of the contract, the plant is transferred free of charge to the State of Senegal — securing a lasting sovereign asset.",
      s1_t: "Build", s1: "Development and construction of the plant over 12 months.",
      s2_t: "Own & Operate", s2: "Optimized ownership and operation over 40 years.",
      s3_t: "Transfer", s3: "Free transfer of the asset to the State at contract end.",
    },
    technical: {
      chapter: "02 — Technical Overview",
      title: "World-class infrastructure, optimized for the Sahel",
      dc: "DC Capacity", ac: "AC Capacity (grid injection)",
      prod: "Estimated annual production", tech: "Technology",
      tech_v: "Bifacial photovoltaic modules", surface: "Total site area",
      loc: "Location", loc_v: "Paoskoto, Kaolack — Senegal",
      height: "Elevated structures", height_v: "≈ 3 m (agrivoltaic)",
      map_title: "Project site", map_desc: "Paoskoto, Kaolack Region",
      feature: "Production optimized for the Sahelian climate through bifacial modules and elevated structures enabling dual land use.",
    },
    finance: {
      chapter: "03 — Economic & Financial Model",
      title: "A secured, low-risk investment",
      capex: "Estimated CAPEX", tariff: "Sale tariff", ppa: "PPA duration",
      lcoe: "Competitive LCOE",
      struct_t: "Indicative financial structure",
      debt: "Senior debt", equity: "Quasi-equity investors", sponsor: "Sponsor",
      rev_t: "Revenue projection (indicative, €M/yr)",
      guarantees_t: "Guarantees & security",
      g1: "Sovereign guarantee from the State of Senegal",
      g2: "Revenues secured by a long-term PPA (25 years)",
      g3: "Single off-taker: Senelec (national utility)",
      g4: "Local banking pool: BNDE & BSIC",
    },
    esg: {
      chapter: "04 — ESG & Impact",
      title: "Measurable impact on environment and communities",
      env_t: "Environment", env_v: "9.9M", env_u: "tons of CO₂ avoided",
      env_d: "Reduction of greenhouse gas emissions over the project lifetime.",
      social_t: "Social", social_v: "1,000+", social_u: "youth trained",
      social_d: "Paid training in solar trades; 60 profiles gain international experience.",
      women_t: "Women empowerment", women_v: "Groups",
      women_d: "Agricultural plots dedicated to women's groups for market gardening.",
      econ_t: "Local economy", econ_v: "Agri + Fish",
      econ_d: "Farming under panels and fish ponds for local food security.",
    },
    agri: {
      chapter: "05 — Agrivoltaic Innovation",
      title: "One hectare, two resources",
      desc: "Agrivoltaics combines energy and agricultural production on the same land. Elevated structures (≈3 m) allow farming and aquaculture beneath the panels, protecting crops from intense sun while generating electricity.",
      u1_t: "Market gardening for women",
      u1: "Women's groups benefit from plots under the installations for market gardening activities.",
      u2_t: "Fish farming for youth",
      u2: "Fish ponds support youth entrepreneurship and local food security.",
      b1: "Dual land use", b2: "Crop protection", b3: "Additional income", b4: "Food security",
    },
    infra: {
      chapter: "06 — Community Development",
      title: "Infrastructure that strengthens local value chains",
      i1_t: "Youth center", i1: "A dedicated space for training and youth entrepreneurship in the region.",
      i2_t: "Cold storage", i2: "Large-capacity positive and negative cold rooms to preserve agricultural and fish products.",
      i3_t: "Development fund", i3: "A local fund finances agriculture, fish farming and micro-enterprises on favorable terms.",
    },
    partners: {
      chapter: "07 — Partners",
      title: "An ecosystem of trusted stakeholders",
      sponsor: "Sponsor", offtaker: "Off-taker",
      technical: "Technical partner", financial: "Financial partners",
    },
    invest: {
      chapter: "08 — Invest",
      title: "Why invest in Horizon Affaires Senegal",
      r1_t: "Stable returns", r1: "Revenues secured by a 25-year fixed-tariff PPA.",
      r2_t: "Strong guarantees", r2: "State sovereign guarantee and national off-taker Senelec.",
      r3_t: "ESG impact", r3: "An asset aligned with international environmental and social standards.",
      cta1: "Request Investment Deck", cta2: "Contact Investment Team",
    },
    monitoring: {
      chapter: "09 — Innovation: Project Monitoring",
      title: "Real-time supervision center",
      subtitle: "Track construction progress, production and impact — live.",
      live: "LIVE", overall: "Overall progress",
      m_output: "Live output", m_installed: "Installed capacity",
      m_energy: "Energy today", m_co2: "CO₂ avoided (cumulative)", m_workforce: "Workforce on site",
      phases_t: "Project phases",
      p_land: "Land preparation", p_install: "Installation",
      p_grid: "Grid connection", p_commission: "Commissioning",
      prod_t: "24h production (MW)",
      map_t: "Interactive site map",
      map_hint: "Click a marker to explore each zone",
      target: "Target",
    },
    zones: {
      solar: { name: "Solar Zone A", type: "Photovoltaic field", desc: "Bifacial modules on elevated structures, the core of power production." },
      agri: { name: "Agrivoltaic Zone", type: "Market gardening", desc: "Vegetable crops under panels, operated by women's groups." },
      fish: { name: "Fish Ponds", type: "Aquaculture", desc: "Breeding ponds supporting youth entrepreneurship." },
      community: { name: "Community Hub", type: "Infrastructure", desc: "Youth center, cold storage and training facilities." },
      grid: { name: "Grid Connection", type: "Network", desc: "250 MWac injection point onto the national Senelec grid." },
    },
    timeline: {
      chapter: "10 — Timeline",
      title: "A project structured over time",
      t1_t: "Development", t1: "Structuring, financing and permitting.",
      t2_t: "Construction", t2: "12 months — civil works, installation, training.",
      t3_t: "Operation", t3: "40 years of optimized plant operation.",
      t4_t: "Transfer", t4: "Free transfer of the asset to the State of Senegal.",
    },
    contact: {
      chapter: "11 — Contact",
      title: "Let's discuss your participation in the project",
      name: "Full name", email: "Business email", org: "Organization",
      interest: "You are", message: "Your message",
      i_investment: "Investor", i_partnership: "Partner", i_technical: "Technical partner",
      i_press: "Press", i_general: "Other",
      send: "Send message", sending: "Sending...",
      success: "Message sent. Our team will get back to you shortly.",
      error: "An error occurred. Please try again.",
      office: "Office", office_v: "Dakar, Senegal",
      ph_name: "e.g. Awa Diop", ph_email: "you@organization.com", ph_org: "e.g. Bank / Fund",
      ph_message: "Describe your interest in the project...",
    },
    footer: {
      tagline: "250 MW solar plant & integrated agrivoltaic hub — Paoskoto, Senegal.",
      links: "Navigation", legal: "Legal information",
      privacy: "Privacy policy", terms: "Legal notice",
      rights: "All rights reserved.",
      contact: "Contact",
    },
  },
};
